const COUNTRY_CODE_REGEX = /^\+[1-9]\d{0,3}$/;
const MOBILE_NUMBER_REGEX = /^\d{6,15}$/;

export function sanitizeCountryCode(countryCode) {
  if (typeof countryCode !== "string") {
    return "";
  }

  return countryCode.replace(/[^\d+]/g, "").trim();
}

export function sanitizeMobileNumber(mobileNumber) {
  if (typeof mobileNumber !== "string") {
    return "";
  }

  return mobileNumber.replace(/\D/g, "").trim();
}

export function validatePhoneNumber(countryCode, mobileNumber) {
  const sanitizedCountryCode = sanitizeCountryCode(countryCode);
  const sanitizedMobileNumber = sanitizeMobileNumber(mobileNumber);

  if (!sanitizedCountryCode) {
    return {
      valid: false,
      error: "Country code is required",
      countryCode: sanitizedCountryCode,
      mobileNumber: sanitizedMobileNumber,
    };
  }

  if (!COUNTRY_CODE_REGEX.test(sanitizedCountryCode)) {
    return {
      valid: false,
      error: "Country code must start with + followed by up to 4 digits",
      countryCode: sanitizedCountryCode,
      mobileNumber: sanitizedMobileNumber,
    };
  }

  if (!sanitizedMobileNumber) {
    return {
      valid: false,
      error: "Mobile number is required",
      countryCode: sanitizedCountryCode,
      mobileNumber: sanitizedMobileNumber,
    };
  }

  if (!MOBILE_NUMBER_REGEX.test(sanitizedMobileNumber)) {
    return {
      valid: false,
      error: "Mobile number must contain 6 to 15 digits",
      countryCode: sanitizedCountryCode,
      mobileNumber: sanitizedMobileNumber,
    };
  }

  if (/^(\d)\1+$/.test(sanitizedMobileNumber)) {
    return {
      valid: false,
      error: "Mobile number looks incorrect. Please check for typos",
      countryCode: sanitizedCountryCode,
      mobileNumber: sanitizedMobileNumber,
    };
  }

  return {
    valid: true,
    countryCode: sanitizedCountryCode,
    mobileNumber: sanitizedMobileNumber,
    fullNumber: `${sanitizedCountryCode} ${sanitizedMobileNumber}`,
  };
}

export default {
  sanitizeCountryCode,
  sanitizeMobileNumber,
  validatePhoneNumber,
};
